export enum ScheduledIntervals {
  NONE = 0,
  FIVE_MINUTES = 300,
  FIFTEEN_MINUTES = 900,
  THIRTY_MINUTES = 1800,
  HOUR = 3600,
  DAY = 86400,
  WEEK = 604800
}
